export default "__VITE_ASSET__Jf3xAyN3__"